import { render, staticRenderFns } from "./LandingLabel.vue?vue&type=template&id=76d5decd&scoped=true"
import script from "./LandingLabel.vue?vue&type=script&lang=ts"
export * from "./LandingLabel.vue?vue&type=script&lang=ts"
import style0 from "./LandingLabel.vue?vue&type=style&index=0&id=76d5decd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5decd",
  null
  
)

export default component.exports